export const limits = {
  min: 0,
  max: 5000000,
  secs: 3,
};

export const MaintenanceFTEs = {
  min: 0,
  max: 5000,
  default: 500,
};

export const MaintenancePersonProd = {
  min: 0,
  max: 30,
  default: 10,
};

export const MaintenanceAnnualFTERate = {
  min: 0,
  max: 150000,
  default: 70000,
};

export const ExtMaintenanceVendSpend = {
  min: 0,
  max: 100000000,
  default: 10000000,
};

export const ExtMaintenanceVendSpendReduce = {
  min: 0,
  max: 30,
  default: 10,
};

export const DownTimeHours = {
  min: 0,
  max: 5000,
  default: 500,
};

export const DownTimeReduce = {
  min: 0,
  max: 10,
  default: 3,
};

export const DownTimeCostPerHour = {
  min: 0,
  max: 150000,
  default: 50000,
};

export const ReplaceAssetBudget = {
  min: 0,
  max: 50000000,
  default: 8000000,
};

export const AssetsLifeExtension = {
  min: 0,
  max: 20,
  default: 6,
};

export const MROSpend = {
  min: 0,
  max: 50000000,
  default: 5000000,
};

export const MroOverSpendReduce = {
  min: 0,
  max: 20,
  default: 10,
};

export const AssetMgmtToolCost = {
  min: 0,
  max: 5000000,
  default: 1500000,
};

export const AssetMgmtCostReduce = {
  min: 0,
  max: 50,
  default: 25,
};

export const SKELETON_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAQAAADYv8WvAAAAEElEQVR42mN8+p+BgRFEAAAWrwPLzYNPyAAAAABJRU5ErkJggg==';
